export default __webpack_public_path__ + "static/media/logo_white.fe45152b.svg";